/**
 * Supabase auth, the account-function client and (Phase 4) the sync engine.
 * Build-time settings come from Vite env (VITE_SUPABASE_URL / VITE_SUPABASE_KEY) so
 * preview builds point at the separate preview Supabase project.
 */
export interface BackendConfig {
  supabaseUrl: string;
  supabaseKey: string;
  emailSignIn: boolean;
}

/** True when a backend is configured. Builds without one never call a server. */
export function hasBackend(cfg: Partial<BackendConfig>): cfg is BackendConfig {
  return Boolean(cfg.supabaseUrl && cfg.supabaseKey);
}

export * from "./account";
export * from "./auth";
export * from "./background";
export * from "./device";
export * from "./error-report";
export * from "./garage";
export * from "./gate";
export * from "./localdb";
export * from "./logo";
export * from "./restore-points";
export * from "./storage";
export * from "./store";
export * from "./sync";
